module.exports = __webpack_public_path__ + "img/times.6b689ede.svg";